import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postProduct } from '../Api'

export default generateApiAction({
  baseType: Types.PRODUCTS.POST,
  api: postProduct,
  responseType: RESPONSETYPE.ID
})



// WEBPACK FOOTER //
// ./src/actions/products/PostAction.js